import { FormikValues } from 'formik'
import { ReactNode } from 'react'

import defaultInputProps from '@/components/Form/defaultProps'
import Field from '@/components/Form/Field'

import Input from './RadioInput'

type RadioProps = {
  children?: ReactNode
}

/**
 * @example
 * <Radio
 *   description={<FormattedMessage id="SomeDescription" defaultMessage="Some Radio" />}
 *   label={<FormattedMessage id="SomeLabel" defaultMessage="Some Label" />}
 *   name="someField"
 *   required
 * >
 *   <Radio.Input
 *     id="someField-0"
 *     label={<FormattedMessage id="SomeOption.ABC" defaultMessage="Option ABC" />}
 *     name="someField"
 *     value="ABC"
 *   />
 *   <Radio.Input
 *     id="someField-1"
 *     label={<FormattedMessage id="SomeOption.DEF" defaultMessage="Option DEF" />}
 *     name="someField"
 *     value="DEF"
 *   />
 *   <Radio.Input
 *     id="someField-2"
 *     label={<FormattedMessage id="SomeOption.123" defaultMessage="Option 123" />}
 *     name="someField"
 *     value="123"
 *   />
 * </Radio>
 */
const Radio = ({ children, ...props }: RadioProps & FormikValues) => {
  return (
    <Field {...defaultInputProps} {...props}>
      {children}
    </Field>
  )
}

Radio.Input = Input
Radio.displayName = 'Radio'

export default Radio
